<template>
  <div :class="['page', { 'page--align-center': shouldCenterPageByZoom }]">
    <div class="container">
      <div class="welcome-header">
        <h2 class="title">中国职业教育质量年度报告满意度调查服务系统</h2>
        <p class="subtitle">欢迎使用问卷填写系统，请阅读填写须知并确认后开始答题。</p>
      </div>

      <section class="section notice-section">
        <h3 class="section-title">填写须知</h3>
        <div v-if="hasQueryParams && currentNotice.paragraphs.length" class="notice-letter">
          <p class="notice-greeting">{{ currentNotice.greeting }}</p>
          <p v-for="(paragraph, index) in currentNotice.paragraphs" :key="index" class="notice-paragraph">
            {{ paragraph }}
          </p>
          <div class="notice-signoff">
            <p v-for="(paragraph, index) in currentNotice.signoff" :key="index">{{ paragraph }}</p>
          </div>
        </div>
        <div v-else-if="!hasQueryParams" class="query-feedback">
          当前访问链接缺少参数，请从学校/系统提供的有效问卷链接重新进入。
        </div>
        <div v-else class="notice-empty">当前问卷参数无效，暂无法展示填写须知，请联系管理员。</div>
      </section>

      <div class="footer-action">
        <div class="footer-left">
          <div class="phone-row">
            <span class="phone-label">手机号</span>
            <el-input v-model.trim="phone" class="phone-input" maxlength="11" placeholder="请输入手机号"></el-input>
          </div>
          <!-- <el-checkbox v-model="agreed" :disabled="!selectedType || !hasQueryParams || validatingPhone">
            我已阅读并同意以上填写须知
          </el-checkbox> -->
        </div>
        <el-button
          type="primary"
          class="start-btn"
          :loading="validatingPhone"
          :disabled="!canStart"
          @click="handleStart"
          >开始答题</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { validPhone } from '@/api/answer.js';

export default {
  name: 'WelcomePage',
  data() {
    return {
      formId: '',
      selectedType: '',
      agreed: false,
      phone: '',
      browserZoom: 1,
      validatingPhone: false,
      // 按业务配置维护以下三个数组（支持字符串和数字）
      studentFormIds: ['213'],
      teacherFormIds: ['17'],
      graduateFormIds: ['26']
    };
  },
  computed: {
    currentYearStart() {
      const date = new Date();
      return date.getMonth() + 1 < 9 ? date.getFullYear() - 1 : date.getFullYear();
    },
    currentAcademicYearLabel() {
      return `${this.currentYearStart}年 9 月 - ${this.currentYearStart + 1}年 8 月`;
    },
    currentNotice() {
      const schoolYear = this.currentAcademicYearLabel;

      if (this.selectedType === 'student') {
        return {
          greeting: '亲爱的同学，你好！',
          paragraphs: [
            `非常感谢您参与这次学生满意度调查。本调查旨在收集您对学校育人工作的满意信息，了解您在上一学年（即 ${schoolYear}）的学习体验情况，以便更好地理解您的需求，促进学校进一步提高办学质量。`,
            '调查采取不记名方式，问卷填写不超过 10 分钟。选项无对错之分，请您仔细阅读每个问题，并按照自己在校学习生活中的真实感受，客观、独立、完整地填写。',
            '您的意见和建议至关重要，我们期待通过这次调查，更好地理解您的需求，促进职业教育办学质量不断提高。'
          ],
          signoff: ['祝你学业精进，未来可期！', '中国职业教育质量年度报告项目组', '二〇二五年十二月']
        };
      }

      if (this.selectedType === 'teacher') {
        return {
          greeting: '尊敬的老师，您好！',
          paragraphs: [
            `非常感谢您参与这次全国职业院校专任教师满意度调查。本调查旨在收集您对学校发展与管理、人才培养和教师发展的满意信息，了解您在上一学年（即 ${schoolYear}）的教学工作体验情况，以便更好地理解您的需求，促进学校提高办学质量。`,
            '调查采取不记名方式，问卷填写不超过 10 分钟。选项无对错之分，请您仔细阅读每个问题，并按照实际感受和真实想法，客观、独立、完整地填写。',
            '您的意见和建议至关重要，我们期待通过这次调查，更好地理解您的需求，促进职业教育办学质量不断提高。'
          ],
          signoff: ['祝您工作愉快，生活如意！', '中国职业教育质量年度报告项目组', '二〇二五年十二月']
        };
      }

      if (this.selectedType === 'graduate') {
        return {
          greeting: '亲爱的校友：',
          paragraphs: [
            '时光荏苒，毕业如歌，你已从校园奔赴人生新的征程。为持续优化办学质量、完善人才培养体系，更好地助力学弟学妹成长成才，我们特开展本次毕业生满意度调查。问卷内容将围绕在校学习、校园生活、就业发展等方面展开，答案无对错之分，你的真实感受与宝贵建议，都是我们前行的重要动力。本次调查实行匿名制，所有数据仅用于教学与办学质量提升分析，严格保密个人信息。恳请你抽出片刻时间，如实填写问卷，为职业教育发展建言献策。衷心感谢你的支持与厚爱，祝你前程似锦、一切顺意！'
          ],
          signoff: ['中国职业教育质量年度报告项目组']
        };
      }

      return {
        greeting: '',
        paragraphs: [],
        signoff: ''
      };
    },
    shouldCenterPageByZoom() {
      return this.browserZoom < 1.5;
    },
    hasQueryParams() {
      const query = this.$route.query || {};
      return Object.keys(query).length > 0;
    },
    canStart() {
      return Boolean(this.hasQueryParams && this.selectedType && this.phone && !this.validatingPhone);
    }
  },
  watch: {
    '$route.query.formId': {
      immediate: true,
      handler(formId) {
        this.initUserTypeByFormId(formId);
      }
    },
    selectedType() {
      this.agreed = false;
    }
  },
  mounted() {
    this.updateBrowserZoom();
    window.addEventListener('resize', this.updateBrowserZoom);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.updateBrowserZoom);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateBrowserZoom);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.updateBrowserZoom);
    }
  },
  methods: {
    getBrowserZoomRatio() {
      // 浏览器没有统一的页面缩放 API，这里通过窗口外框和可视区比例做近似判断。
      const widthRatio = window.innerWidth ? window.outerWidth / window.innerWidth : 1;
      const heightRatio = window.innerHeight ? window.outerHeight / window.innerHeight : 1;
      const zoomRatio = Math.min(widthRatio || 1, heightRatio || 1);
      return Number.isFinite(zoomRatio) && zoomRatio > 0 ? Number(zoomRatio.toFixed(2)) : 1;
    },
    updateBrowserZoom() {
      this.browserZoom = this.getBrowserZoomRatio();
    },
    normalizeId(value) {
      return String(value || '').trim();
    },
    matchByFormId(formId) {
      const normalizedFormId = this.normalizeId(formId);
      if (!normalizedFormId) {
        return '';
      }

      const studentSet = new Set(this.studentFormIds.map(this.normalizeId));
      const teacherSet = new Set(this.teacherFormIds.map(this.normalizeId));
      const graduateSet = new Set(this.graduateFormIds.map(this.normalizeId));

      if (studentSet.has(normalizedFormId)) {
        return 'student';
      }
      if (teacherSet.has(normalizedFormId)) {
        return 'teacher';
      }
      if (graduateSet.has(normalizedFormId)) {
        return 'graduate';
      }
      return '';
    },
    initUserTypeByFormId(formId) {
      this.formId = this.normalizeId(formId);
      this.selectedType = this.matchByFormId(this.formId);
    },
    checkMobile(mobile) {
      const re = /^1[3-9][0-9]{9}$/;
      const result = re.test(mobile);
      if (!result) {
        this.$message.error('请检查手机号码');
        return false;
      }
      return true;
    },
    handleStart() {
      if (!this.hasQueryParams) {
        this.$message.error('当前访问链接缺少参数，请从有效问卷链接进入');
        return;
      }

      if (!this.selectedType) {
        this.$message.error('未识别到用户类别，请联系管理员核对 formId 配置');
        return;
      }

      const mobileOk = this.checkMobile(this.phone);
      if (!mobileOk) {
        return;
      }

      this.validatingPhone = true;
      validPhone({
        id: this.formId,
        collegeId: this.$route.query.collegeId,
        phone: this.phone,
        s: this.$route.query.s
      })
        .then(res => {
          const { success, msg } = res.data || {};
          if (success) {
            this.$router.push({
              path: '/answer',
              query: {
                ...this.$route.query,
                userType: this.selectedType,
                phone: this.phone
              }
            });
          } else {
            this.$message.error(msg || '手机号校验失败，请稍后重试');
          }
        })
        .catch(() => {
          this.$message.error('手机号校验失败，请稍后重试');
        })
        .finally(() => {
          this.validatingPhone = false;
        });
    }
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  height: 100vh;
  padding: 24px 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  overflow: auto;
  background: linear-gradient(#2489f9, #f4f8ff);
}

.page--align-center {
  align-items: center;
}

.container {
  width: 100%;
  max-width: 1024px;
  height: 85%;
  min-height: 600px;
  padding: 24px 28px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #fff;
  text-align: left;
  box-shadow: 0 14px 40px rgba(17, 71, 143, 0.12);
  display: flex;
  flex-direction: column;
}

.welcome-header {
  text-align: center;
  margin-bottom: 16px;
  flex-shrink: 0;
  margin-bottom: 20px;
}

.title {
  margin: 0;
  font-size: 30px;
  font-weight: bold;
  color: #2187f9;
}

.subtitle {
  margin: 14px 0 0;
  color: #5f6b7a;
  font-size: 15px;
}

.section {
  flex: 1;
  min-height: 0;
  border: 1px solid #ebf2fb;
  border-radius: 10px;
  padding: 18px;
  background: #fbfdff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.section-title {
  margin: 0 0 14px;
  font-size: 18px;
  color: #24364d;
  flex-shrink: 0;
}

.notice-letter {
  /* min-height: 100%; */
  flex: 1;
  padding: 16px 18px;
  border-radius: 10px;
  background: #ffffff;
  border: 1px solid #e9f2fd;
  overflow-y: auto;
}

.notice-paragraph {
  margin: 0 0 10px;
  text-indent: 2em;
  line-height: 2;
  color: #415167;
  font-size: 16px;
}

.notice-greeting {
  margin: 0 0 12px;
  line-height: 2;
  color: #415167;
  font-size: 16px;
}

.notice-signoff {
  margin: 48px 0 0;
  color: #415167;
  font-size: 16px;
  text-align: right;
}

.notice-empty {
  line-height: 44px;
  color: #9aa9bb;
  font-size: 14px;
}

.query-feedback {
  border: 1px solid #f5d5b4;
  background: #fff8f1;
  color: #c56a16;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 14px;
  line-height: 1.7;
}

.footer-action {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #dbe8f8;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
}

.footer-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.phone-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.phone-label {
  color: #415167;
  font-size: 14px;
  flex-shrink: 0;
}

.phone-input {
  max-width: 280px;
}

.start-btn {
  min-width: 120px;
}

@media (max-width: 960px) {
  .page {
    padding: 12px;
  }

  .container {
    width: 100%;
    padding: 16px;
    border-radius: 10px;
  }

  .title {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
  }

  .footer-action {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .footer-left {
    width: 100%;
  }

  .phone-row {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }

  .phone-input {
    width: 100%;
    max-width: none;
  }

  .start-btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/wel/index.vue